import { z } from 'zod';
import { CancelJobReasonSchema as APICancelJobReasonSchema } from 'api/domain/entities/Job';

export const CancelJobReasonSchema = APICancelJobReasonSchema;
export type CancelJobReason = z.infer<typeof CancelJobReasonSchema> | 'other';
